import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChatUIState {
    open: boolean;
    chatId?: string;
    tripId?: string;
    feedbackId?: string;
    chatData?: any;
    action?: any;
    journeyTitle?: string;
}

const initialState: ChatUIState = {
    open: false,
    chatId: undefined,
    tripId: undefined,
    feedbackId: undefined,
    chatData: undefined,
    action: undefined,
    journeyTitle: undefined,
};

export const chatsUISlice = createSlice({
    name: 'chatsUI',
    initialState,
    reducers: {
        openChat(state, action: PayloadAction<{ chatId?: string; data?: any; action?: any, tripId?: string; feedbackId?: string; journeyTitle?: string }>) {
            state.open = true;
            state.chatId = action.payload.chatId;
            state.feedbackId = action.payload.feedbackId;
            state.chatData = action.payload.data;
            state.tripId = action.payload.tripId;
            state.action = action.payload.action;
            state.journeyTitle = action.payload.journeyTitle;
        },
        closeChat(state) {
            state.open = false;
            state.chatId = undefined;
            state.feedbackId = undefined
            state.chatData = undefined;
            state.tripId = undefined;
            state.action = undefined;
            state.journeyTitle = undefined;
        },
    },
});
export const { openChat, closeChat } = chatsUISlice.actions;

export default chatsUISlice.reducer;